/**
 * Picks the unified-billing start date when migrating a legacy OMS or WMS
 * monthly subscription.
 */
export function getLegacySubscriptionBillingStartDate({
  now,
  lastBilledDate,
  turnedOnAt,
}: {
  now: Date;
  lastBilledDate?: Date | null;
  turnedOnAt?: Date | null;
}): Date {
  if (lastBilledDate) {
    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1));
  }
  if (turnedOnAt && turnedOnAt > now) {
    return new Date(turnedOnAt);
  }
  return now;
}
